export const purchaseInvoice = {
	titlePage: "Facturas fiscales de compra",
	description:
		"La factura fiscal de compra es el documento referente al movimiento del inventario de las mercancías que su empresa está recibiendo. Aquí será posible importar sus facturas, ver su historial de importación, además del detalle por producto de las mismas.",
	tabs: {
		historyNf: "Historial de importación",
		detailingByProduct: "Detalle por producto",
		importationInvoices: "Importación de facturas fiscales",
	},
	importHistory: {
		columns: {
			nf: "NF",
			supplier: "Proveedor",
			emission: "Fecha Emisión",
			createdAt: "Fecha de Importación",
			totalValue: "Valor",
			status: "Estado",
			statusMessage: {
				processed: "Procesada",
				Unprocessed: "No Procesada",
				Deprocessed: "Desprocesada",
			},
		},
		fields: {
			searchNf: "Número de la factura",
			searchSupplier: "Nombre del proveedor",
			searchDateEmissionRange: {
				start: "Inicio Fecha Emisión",
				end: "Final Fecha Emisión",
			},
			searchDateImportRange: {
				start: "Inicio Fecha Importación",
				end: "Final Fecha Importación",
			},
		},
		table: {
			emptyText: "No existen facturas para mostrar",
			reportPrint: "Historial de importación",
		},
		excelExportHistoryImport: {
			filename: "historial_importacion",
			title: "Historial de importación",
		},
		modalDelete: {
			title: "Eliminar factura",
			cancelText: "Cancelar",
			okText: "Eliminar",
			message1: "La eliminación de la NF",
			message2: "es permanente. ¿Desea continuar de todos modos?",
		},
		modalUnprocess: {
			title: "Desprocesar factura",
			cancelText: "Cancelar",
			closeText: "Cerrar",
			okText: "Desprocesar factura",
			message1: "Al desprocesar una factura usted genera las siguientes acciones:",
			message2: "Los productos agregados en el inventario serán eliminados;",
			message3: "El registro de la factura será eliminado de las cuentas por pagar.",
			message4: "¿Desea desprocesar la factura de todos modos?",
		},
		actionTable: {
			delete: "Eliminar",
			unprocess: "Desprocesar",
			download: "Descargar",
		},
	},
	detailingProduct: {
		unassociatedProduct: "Producto no asociado",
		infoBasCalcUnitCost:
			"La base de cálculo del costo unitario es: Valor total - Descuento + IPI + ICMS + Flete + Seguro + Otros gastos / Cantidad",
		columns: {
			nf: "NF",
			supplierName: "Proveedor",
			emission: "Fecha Emisión",
			unitQuantity: "CANT (NF)",
			commercialUnit: "UN (NF)",
			unitValue: "Costo Unitario (NF)",
			totalValue: "Costo total (NF)",
			inputDate: "Fecha entrada inventario",
			invoiceEntry: "Producto Importado",
			associateProduct: "Producto asociado (ZIG)",
			unitQuantityZig: "CANT (ZIG)",
			commercialUnitZig: "UN (ZIG)",
			unitValueZig: "Costo unitario (ZIG)",
		},
		excelExportDetailingProduct: {
			fileName: "detailing_product",
			title: "Detalle por producto",
		},
		fields: {
			searchNf: "Ingrese el número de la factura",
			searchSupplier: "Ingrese el nombre del emisor",
			searchDateRange: {
				processedAtDate: {
					start: "Inicio fecha entrada",
					end: "Final fecha entrada",
				},
				emissionDate: {
					start: "Inicio fecha emisión",
					end: "Final fecha emisión",
				},
			},
			isAssociatedProduct: "Solo productos no asociados",
		},
		emptyText: "No existen productos no asociados en este perfil fiscal",
	},
	importationInvoices: {
		title: "Seleccione un perfil fiscal para comenzar",
		emptyText: "Ninguna Factura Fiscal de Compra",
		fiscalProfiles: "Perfil fiscal",
		issueDate: "Filtrar por fecha",
		issuer: "Filtrar por nombre del proveedor",
		status: "Filtrar por estado",
		btnUpdate: "Actualizar",
		xmlUnavailableInfo:
			"Para disponibilizar los archivos XML con estado indisponible es necesario realizar la manifestación de la factura. En caso de dudas en la manifestación consulte a su contador.",
		modalInfoImport: {
			notAllowed: {
				title: "No autorizada",
			},
			xmlUnavailable: {
				title: "XML indisponible",
				reason:
					"El código XML de esta factura fiscal aún no está disponible. Aguarde para hacer la importación de la factura fiscal.",
			},
		},
		fiscalProfilesOptions: {
			disabledMessage:
				"Perfil fiscal no está habilitado para buscar facturas fiscales, edite el perfil antes de continuar",
			notEnabled: "(NO HABILITADO)",
		},
		columns: {
			issuerName: "Proveedor",
			issuerCnpj: "CNPJ o CPF",
			issueDate: "Fecha Emisión",
			totalValue: "Valor de la Factura",
			status: {
				title: "Estado",
				imported: "Importada",
				authorized: "Autorizada",
				notAllowed: "No autorizada",
				xmlUnavailable: "XML indisponible",
			},
		},
	},
};
